import { getHeaders } from "../authentication";

const initialState = {
  notes: null,
  error: null,
  isFetching: false,
};

const GET_NOTES = 'GET_NOTES';
const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS';
const GET_NOTES_FAILURE = 'GET_NOTES_FAILURE';
const GET_NOTES_RESET = 'GET_NOTES_RESET';

export const getPharmacyNotesNew = (pharmacyId) => {
  return {
    types: [GET_NOTES, GET_NOTES_SUCCESS, GET_NOTES_FAILURE],
    payload: {
      request: {
        url: `/notes/${pharmacyId}`,
        method: 'GET',
        headers :getHeaders(),
      },
    },
  };
};

export const getPharmacyNotesReset = () => ({
  type: GET_NOTES_RESET,
});

const getNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTES:
      return { ...state, isFetching: true };
    case GET_NOTES_SUCCESS:
      return { ...state, isFetching: false, notes: action.payload.data.data };
    case GET_NOTES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error?.response?.data?.message || action.error.message,
      };
    case GET_NOTES_RESET:
      return { notes: null, isFetching: false, error: null };
    default:
      return state;
  }
};

export default getNotesReducer;
